export { default as CmsSectionalHeader } from './CmsSectionalHeader';
